/**
 * Customer Settings V2 — "Agreements" section: presence-only mount
 * of the legacy `BillingAccountAgreementTab`.
 *
 * Contains:
 * - AgreementsSection (default export)
 */

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsSection } from '@sophocles/views/settings/components';
import BillingAccountAgreementTab from '@sophocles/views/settings/components/BillingAccountAgreementTab';

import { accountingOnlyChip } from './chips';

export default function AgreementsSection({ accountId, canEditAgreements }) {
  const { t } = useTranslation();
  return (
    <SettingsSection
      id="settings-agreements"
      icon={<ReceiptLongIcon />}
      title={t('customerSettings.v2.agreements', 'Agreements')}
      description={t('customerSettings.agreementsDescription', 'Billing account agreements.')}
      chip={accountingOnlyChip(t)}
    >
      <BillingAccountAgreementTab accountId={accountId} canEdit={canEditAgreements} />
    </SettingsSection>
  );
}
